import { Flex, Modal, Text, ThemeIcon } from '@mantine/core';
import React from 'react';
import { IconExclamationCircle } from '@tabler/icons-react';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export function GenericErrorModal({ opened, onClose: handleClose }: Props) {
  return (
    <>
      <Modal opened={opened} onClose={handleClose}>
        <Flex flex={1} align={'center'} direction={'column'}>
          <ThemeIcon variant="light" radius="xl" size="xl" color="red">
            <IconExclamationCircle style={{ width: '70%', height: '70%' }} />
          </ThemeIcon>
          <Text ta={'center'} my={'xl'} fw={'500'}>
            Something went wrong. Please try again, and if the problem persists, contact support.
          </Text>
        </Flex>
      </Modal>
    </>
  );
}
